export const ISO_8601_DATE = 'YYYY-MM-DD';
export const ISO_8601_TIME = 'HH:mm:ss';
export const ISO_8601 = `${ISO_8601_DATE}T${ISO_8601_TIME}`;
export const DATE_DISPLAY = 'MM/DD/YYYY';
export const DAYJS_FORMAT = 'YYYY-MM-DD HH:mm:ss';
